import script from "./OrderInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderInfo.vue?vue&type=script&setup=true&lang=js"

import "./OrderInfo.vue?vue&type=style&index=0&id=5f187d18&lang=scss&scoped=true"

import exportComponent from "/home/ecs-user/software/jenkins/workspace/smallshop-website-uat/smallshop-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f187d18"]])

export default __exports__